import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
// import Category from 'src/svgComponents/sidebarIcons/Category'
// import MainCategory from 'src/svgComponents/sidebarIcons/Category'
// import Roles from 'src/svgComponents/sidebarIcons/Roles'
// import UserCircle from 'src/svgComponents/sidebarIcons/UesrCircle'
// import Vender from 'src/svgComponents/sidebarIcons/UserGroupCircle'
import RolesPermissions from 'src/svgComponents/sidebarIcons/Roles'
import Dashboard from 'src/svgComponents/sidebarIcons/Dashboard'
import SubAdmin from 'src/svgComponents/sidebarIcons/SubAdmin'
import { PATH_DASHBOARD, FOOD_ITEMS, GROCERY_ITEMS, SUB_VENDOR, ROLE_PERMISSION, EVENTS, TRAVEL, NGO, ORDER, SUPPORT_PATH, PAYOUT, ADVERTISEMENT, SETTING_PATH } from 'src/routes/paths';
import useStore from 'src/contexts/AuthProvider';
import LunchDiningIcon from 'src/svgComponents/LunchDiningIcon'
import RestaurantMenuIcon from 'src/svgComponents/RestaurantMenuIcon'
import PeopleAltIcon from 'src/svgComponents/PeopleAltIcon';
import OrderIcon from 'src/svgComponents/OrderIcon';
import HeadsetMicIcon from 'src/svgComponents/HeadsetMicIcon';
import { ListItemButton, ListItemIcon, Box, List, Collapse } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PaidIcon from 'src/svgComponents/PaidIcon';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import FeedbackIcon from 'src/svgComponents/FeedbackIcon';
import SettingIcon from 'src/svgComponents/SettingCircle';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import useLogout from 'src/hooks/useLogout';

let orderList = [
	{
		linkText: 'Pending Orders',
		link: ORDER.general.pendingOrder,
		linkIconElem: "",
		permission: "pending_order",
		status: 2
	},
	{
		linkText: 'Completed Orders',
		link: ORDER.general.completedOrder,
		linkIconElem: "",
		permission: "completed_order",
		status: 2
	},
	{
		linkText: 'Cancelled Orders',
		link: ORDER.general.cancelledOrder,
		linkIconElem: "",
		permission: "completed_order",
		status: 2
	},
	// {
	// 	linkText: 'Disputed Orders',
	// 	link: ORDER.general.disputedOrder,
	// 	linkIconElem: "",
	// 	permission: "disputed_order",
	// 	status: 2
	// },
]

let payoutList = [
	{
		linkText: 'My Payment',
		link: PAYOUT.general.pendingPayout,
		linkIconElem: "",
		permission: "my_payment",
		status: 2
	},
	// {
	// 	linkText: 'Completed Payout',
	// 	link: PAYOUT.general.completedPayout,
	// 	linkIconElem: "",
	// 	permission: "completed_payout",
	// 	status: 2
	// },
	// {
	// 	linkText: 'Transaction List',
	// 	link: PAYOUT.general.transactionList,
	// 	linkIconElem: "",
	// 	permission: "transactions_list",
	// 	status: 2
	// },
]

let eventList = [
	{
		linkText: 'Event List',
		link: EVENTS.general.eventList,
		linkIconElem: "",
		permission: "event_list",
		status: 2
	},
	{
		linkText: 'Pending Tickets',
		link: EVENTS.general.pendingTickets,
		linkIconElem: "",
		permission: "pending_tickets",
		status: 2
	},
	{
		linkText: 'Booked Tickets',
		link: EVENTS.general.bookedTickets,
		linkIconElem: "",
		permission: "booked_tickets",
		status: 2
	}
]
let charityList = [
	{
		linkText: 'Charity Event List',
		link: NGO.general.ngomenu,
		linkIconElem: "",
		permission: "charity_event_list",
		status: 2
	},
	{
		linkText: 'Charity Transaction',
		link: NGO.general.charityTransaction,
		linkIconElem: "",
		permission: "charity_transactions",
		status: 2
	}
]
const securitySettingData = [
	{
		linkText: 'Change Password',
		link: PATH_DASHBOARD.general.changePassword,
		linkIconElem: "",
		permission: "",
		status: 2
	},
	{
		linkText: '2 Step Email Authentication',
		link: SETTING_PATH.general.twoFactor,
		linkIconElem: "",
		permission: "",
		status: 2
	},
	{
		linkText: 'Bank Details',
		link: SETTING_PATH.general.bankDetail,
		linkIconElem: "",
		permission: "",
		status: 2
	}
]
const sidebarData = [
	{
		linkText: 'Dashboard',
		link: PATH_DASHBOARD.general.dashboard,
		linkIconElem: <Dashboard color={"#fff"} />,
		permission: "",
		subMenu: []
	},
	{
		linkText: 'Sub Vendor',
		link: SUB_VENDOR.general.subVendor,
		linkIconElem: <PeopleAltIcon color={"#fff"} />,
		permission: "sub_vendor",
		subMenu: []
	},
	{
		linkText: 'Role Permission',
		link: ROLE_PERMISSION.general.role,
		linkIconElem: <RolesPermissions color={"#fff"} />,
		permission: "role_permission",
		subMenu: []
	},

	// {
	// 	linkText: 'Food Category',
	// 	link: FOOD_ITEMS.general.foodCategory,
	// 	linkIconElem: <Category color={"#fff"} />,
	// 	permission: "food_category"
	// subMenu: []
	// },
	// {
	// 	linkText: 'Grocery Category',
	// 	link: GROCERY_ITEMS.general.grocerCategory,
	// 	linkIconElem: <Category color={"#fff"} />,
	// 	permission: "grocery_category",
	// subMenu: []
	// },
	{
		linkText: 'Food Menu',
		link: FOOD_ITEMS.general.foodMenu,
		linkIconElem: <RestaurantMenuIcon color={"#fff"} />,
		permission: "food_menu",
		subMenu: []
	},
	{
		linkText: 'Food Dish Items',
		link: FOOD_ITEMS.general.foodItem,
		linkIconElem: <LunchDiningIcon color={"#fff"} />,
		permission: "food_items",
		subMenu: []
	},
	{
		linkText: 'Grocery Menu',
		link: GROCERY_ITEMS.general.groceryMenu,
		linkIconElem: <RestaurantMenuIcon color={"#fff"} />,
		permission: "grocery_menu",
		subMenu: []
	},
	{
		linkText: 'Grocery Items',
		link: GROCERY_ITEMS.general.groceryItem,
		linkIconElem: <LunchDiningIcon color={"#fff"} />,
		permission: "grocery_items",
		subMenu: []
	},
	{
		linkText: 'Events',
		link: EVENTS.general.eventmenu,
		linkIconElem: <SubAdmin color={"#fff"} />,
		permission: "events",
		subMenu: eventList
	},
	{
		linkText: 'Travels',
		link: TRAVEL.general.travelmenu,
		linkIconElem: <SubAdmin color={"#fff"} />,
		permission: "travels",
		subMenu: []
	},
	{
		linkText: 'Ngo',
		link: NGO.general.ngomenu,
		linkIconElem: <SubAdmin color={"#fff"} />,
		permission: "ngo",
		subMenu: charityList
	},
	{
		linkText: 'Order',
		link: ORDER.general.pendingOrder,
		linkIconElem: <OrderIcon color={"#fff"} />,
		permission: "order",
		subMenu: orderList
	},
	{
		linkText: 'Payment',
		link: PAYOUT.general.pendingPayout,
		linkIconElem: <PaidIcon color={"#fff"} />,
		permission: "payment",
		subMenu: payoutList
	},
	{
		linkText: 'Advertisement',
		link: ADVERTISEMENT.general.advertisement,
		linkIconElem: <NewReleasesIcon color={"#fff"} />,
		permission: "advertistment",
		subMenu: []
	},
	{
		linkText: 'Support Ticket',
		link: SUPPORT_PATH.general.supportTicket,
		linkIconElem: <HeadsetMicIcon color={"#fff"} />,
		permission: "support_ticket",
		subMenu: []
	},
	{
		linkText: 'Security Setting',
		link: SETTING_PATH.general.supportTicket,
		linkIconElem: <SettingIcon color={"#fff"} />,
		permission: "security_setting",
		subMenu: securitySettingData
	},
	{
		linkText: 'FeedBack Rating',
		link: SUPPORT_PATH.general.feedBackRating,
		linkIconElem: <FeedbackIcon color={"#fff"} />,
		permission: "feedback_rating",
		subMenu: []
	},
	// {
	// 	linkText: 'Logout',
	// 	link: SUPPORT_PATH.general.feedBackRating,
	// 	linkIconElem: <FeedbackIcon color={"#fff"} />,
	// 	permission: "feedback_rating",
	// 	subMenu: []
	// },
]

const MainSidebar = ({ sidebarToogle, setSidebarToogle }) => {
	const location = useLocation();
	const [open, setOpen] = React.useState(true);
	const locationData = useStore((state) => state.locationData);
	const permissionsData = useStore((state) => state.permissions);
	const sidebarContentBoxRef = useRef(null);
	const [searchValue, setSearchValue] = useState('');
	const [expanded, setExpanded] = React.useState('panel1');
	const sidebarRef = useRef(null);
	console.log(sidebarToogle, "sidebarToogle")
	let activeLink = location.pathname;
	const handleLinkClick = () => {
		setSidebarToogle(false)
	}
	// Sidebar Menu Functionality
	const handleSubmenuChange = (panel) => (event, newExpanded) => {
		setExpanded(newExpanded ? panel : false);
	};
	// Close the sidebar when clicking outside
	// useEffect(() => {
	// 	const handleClickOutside = (event) => {
	// 		if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
	// 			setSidebarToogle(false);
	// 		}
	// 	};

	// 	document.addEventListener('mousedown', handleClickOutside);
	// 	return () => {
	// 		document.removeEventListener('mousedown', handleClickOutside);
	// 	};
	// }, [sidebarToogle, setSidebarToogle]);

	// useEffect(() => {
	// 	sidebarContentBoxRef?.current?.addEventListener('scroll', () => {
	// 		if (sidebarContentBoxRef.current.scrollTop > 10) {
	// 			sidebarContentBoxRef.current.classList.add('scrolling');
	// 		} else {
	// 			sidebarContentBoxRef.current.classList.remove('scrolling');
	// 		}
	// 	});
	// }, []);

	const handleClick = () => {
		setOpen(!open);
	};
	const logout = useLogout();

	const handleLogout = async () => {
		try {
			await logout();
			//navigate(PATH_AUTH.login);
			// handleClose();
		} catch (error) {
			// enqueueSnackbar('unable to logout', { variant: 'error' });
		}
	};

	return (
		<Box ref={sidebarRef} className={`main_sidebar_wrapper ${sidebarToogle ? 'open' : ''}`}>
			<List>
				{sidebarData.map(({ linkText, link, linkIconElem, permission, subMenu, id }, index) => {
					if (permission !== '') {
						return permissionsData?.[permission]?.substring(0, 1) === '1' ? (
							<SidebarMenuItem
								key={index}
								permissionsData={permissionsData}
								activeLink={activeLink}
								subMenu={subMenu}
								link={link}
								linkIconElem={linkIconElem}
								linkText={linkText}
								handleLinkClick={handleLinkClick}
							/>
						) : (
							<></>
						);
					} else {
						return (
							<SidebarMenuItem
								key={index}
								activeLink={activeLink}
								subMenu={subMenu}
								link={link}
								linkIconElem={linkIconElem}
								linkText={linkText}
								handleLinkClick={handleLinkClick}
							/>
						);
					}
				})}
				<ListItemButton onClick={() => handleLogout()} key={10000} className={`main_sidebar_item`}>
					<ListItemIcon sx={{ minWidth: 'unset', width: '30px', color: '#fff' }}>
						<ExitToAppOutlinedIcon style={{ fontSize: '18px' }} />
					</ListItemIcon>
					<span className='main_sidebar_link_text'>Logout</span>
				</ListItemButton>
			</List>
		</Box>
	);
};


export default MainSidebar

const SidebarMenuItem = ({ index, activeLink, link, linkIconElem, linkText, subMenu, permissionsData, handleLinkClick }) => {

	const [openSubMenu, setOpenSubMenu] = useState(false);

	const handleClick = () => {
		setOpenSubMenu(!openSubMenu);
	};
	let navigate = useNavigate();
	const handleClickOnlyLink = () => {
		navigate(link)
		handleLinkClick()
	}


	return (<>{subMenu.length === 0 ? <ListItemButton onClick={handleClickOnlyLink} key={index} className={`main_sidebar_item ${activeLink === link ? 'isActive' : ''}`}>
		<ListItemIcon sx={{ minWidth: 'unset', width: '30px', color: '#fff' }}>
			{linkIconElem}
		</ListItemIcon>
		<span className='main_sidebar_link_text text_limit_180'>{linkText}</span>
	</ListItemButton >
		:
		<>
			<ListItemButton className={`main_sidebar_item `} onClick={handleClick}>
				<ListItemIcon sx={{ minWidth: 'unset', width: '30px', color: '#fff' }}>
					{linkIconElem}
				</ListItemIcon>
				<span className='main_sidebar_link_text text_limit_180'>{linkText}</span>
				{openSubMenu ? <ExpandLess style={{ color: '#fff' }} /> : <ExpandMore style={{ color: '#fff' }} />}
			</ListItemButton>
			<Collapse in={openSubMenu} timeout="auto" unmountOnExit>
				<List component="div" disablePadding sx={{ display: 'flex', flexDirection: 'column', py: 1 }}>
					{subMenu.map((item, index) => {
						if (item.permission !== '') {
							return permissionsData?.[item.permission]?.substring(0, 1) === "1" ? <ListItemButton onClick={() => navigate(item.link)} className={`main_sidebar_item sublink ${activeLink === item.link ? 'isActive' : ''}`} key={index} sx={{ pl: 4, py: 1 }}>
								<ListItemIcon sx={{ minWidth: 'unset', width: '30px', color: '#fff' }}>
									{item.linkIconElem}
								</ListItemIcon>
								<span className='main_sidebar_link_text text_limit_180'>{item.linkText}</span>
							</ListItemButton> : <></>
						} else {
							return <ListItemButton onClick={() => navigate(item.link)} className={`main_sidebar_item sublink ${activeLink === item.link ? 'isActive' : ''}`} key={index} sx={{ pl: 4, py: 1 }}>
								<ListItemIcon sx={{ minWidth: 'unset', width: '30px', color: '#fff' }}>
									{item.linkIconElem}
								</ListItemIcon>
								<span className='main_sidebar_link_text text_limit_180'>{item.linkText}</span>
							</ListItemButton>
						}
					})}
				</List>
			</Collapse>
		</>
	}
	</>)
}